export default {
    API_ENDPOINT: 'https://evening-sea-10749.herokuapp.com/api'
  }
  
  
  //http://localhost:8000/api
  //https://heroku link goes here